import { gsap, TweenLite } from 'gsap'
import helper from '../lib/helper'

const reviews = {
    interval: 4000,
    permenantData: $('.cell-review-wrapper'),
    data: $('.cell-review-wrapper'),
    usedData: null,
    queueIndex: 4,
    visibleIndex: 0,
    pairHeight: 0,
    timer: null,
    currentVisibleEl: null,
    init: function () {
        let $reviewsList = $('.cell-review-wrapper')
        // Stops the functionality if the current element is out of the viewport
        if ($reviewsList.length) {
            let _this = reviews

            _this.timer = new helper.timer(function () {
                // Stops the functionality if the current element is not in the current tab
                if (document.hidden) {
                    return
                }
                // 1. Find the current element
                let $currentVisibleEl = $(
                    $('.cell-review-wrapper')[_this.visibleIndex]
                )
                _this.currentVisibleEl = $currentVisibleEl
                // 2. Select new content and add display: none class
                let $newElement = $($('.cell-review-wrapper')[_this.queueIndex])
                let cloned = $newElement.clone()
                cloned
                    .css('display', 'block')
                    .width('45%')
                    .appendTo('body')
                    .css({
                        position: 'absolute',
                        lef: '-1000px',
                        bottom: '-1000px',
                    })

                // 3. Animate fade out
                $currentVisibleEl.find('.cell-review').addClass('fade-out')
                setTimeout(() => {
                    // Get current height and fix it
                    let oldHeight = $currentVisibleEl.height()
                    $currentVisibleEl.height(oldHeight)

                    $newElement
                        .find('.cell-review')
                        .addClass('placeholder-element')

                    // 4. Compair height with pairing element and then select the greater one
                    let pairHeight
                    if (_this.visibleIndex % 2 === 0) {
                        pairHeight = $currentVisibleEl.next().height()
                    } else {
                        pairHeight = $currentVisibleEl.prev().height()
                    }
                    _this.pairHeight = pairHeight
                    // 4.1 Animate height
                    let targetHeight =
                        pairHeight > $(cloned).height()
                            ? pairHeight
                            : $(cloned).height()
                    TweenLite.set($currentVisibleEl, {
                        height: targetHeight,
                    })
                    TweenLite.from($currentVisibleEl, 0.3, {
                        height: oldHeight,
                        delay: 0,
                        ease: 'ease-in-out',
                    })

                    // Remove the cloned element
                    cloned.remove()

                    // Animate to height: 'auto'
                    setTimeout(() => {
                        $('.cell-review-wrapper').each((index, review) => {
                            const reviewsTimeline = gsap.timeline({
                                paused: true,
                            })
                            reviewsTimeline
                                .set(review, {
                                    height: $(review).height(),
                                })
                                .to(review, {
                                    height: 'auto',
                                    duration: 0.3,
                                })

                            reviewsTimeline.play()
                        })
                        // 5. Swap the 2 elements
                        jQuery.fn.swapWith = function (to) {
                            return this.each(function () {
                                var copy_to = $(to).clone(true)
                                var copy_from = $(this).clone(true)
                                $(to).replaceWith(copy_from)
                                $(this).replaceWith(copy_to)
                            })
                        }

                        $($currentVisibleEl).swapWith($newElement)

                        $('.cell-review').removeClass(
                            'fade-out placeholder-element'
                        )

                        $($('.cell-review-wrapper')[_this.visibleIndex])
                            .find('.cell-review')
                            .addClass('fade-in')

                        setTimeout(() => {
                            // 6. Update indexes
                            if (
                                _this.queueIndex <
                                $('.cell-review-wrapper').length - 1
                            ) {
                                _this.queueIndex++
                            } else {
                                _this.queueIndex = 4
                            }
                            if (_this.visibleIndex === 3) {
                                _this.visibleIndex = 0
                            } else {
                                _this.visibleIndex++
                            }
                            // 7. Clear inline styles
                            $('.cell-review').removeClass(
                                'fade-in fade-out placeholder-element'
                            )
                            $('.cell-review-wrapper').removeAttr('style')
                        }, 1000)
                    }, 1000)
                }, 1000)
            }, _this.interval)

            $(window).on('load resize orientationchange scroll', function () {
                if (
                    !helper.isElementInViewport(
                        $('.reviews-wrapper'),
                        'partialInView'
                    ) ||
                    $('.cell-review-wrapper').length <= 4 ||
                    $(window).width() < 1025
                ) {
                    $('.cell-review').removeClass(
                        'placeholder-element fade-in fade-out'
                    )
                    reviews.timer.stop()
                    return
                } else {
                    reviews.timer.reset(reviews.interval)
                }
            })
        }
    },
}

reviews.init()
